import React, { useState } from 'react';
import { Label, Wrapper, BoldText } from './SheetSelector.styles';
import { ApSimpleDropdown } from '@alixpartners/ui-components';
import Modal from 'components/Modal';

const SheetSelector = ({
	selectedFile,
	setSelectedSheet,
	sheetOption,
	setSheetOption,
}) => {
	const [isShowModal, setIsShowModal] = useState(false);

	const onSheetSelectionHandler = value => {
		const sheet = selectedFile?.sheets.find(
			sheet => sheet.sheetName === value.value
		);
		setSheetOption(value);
		setSelectedSheet(sheet);
		setIsShowModal(true);
	};

	return (
		<Wrapper>
			<Label>Select Sheet:</Label>
			<ApSimpleDropdown
				onChange={onSheetSelectionHandler}
				options={selectedFile?.sheets?.map(sheet => {
					return { label: sheet?.sheetName, value: sheet?.sheetName };
				})}
				selected={sheetOption}
			/>

			{isShowModal && (
				<Modal
					title="Note"
					width="620px"
					zIndex="10000000"
					cancelLabel={'Continue'}
					onClose={() => setIsShowModal(false)}
				>
					<p>
						<BoldText>Invoice Date</BoldText>: If the invoice date is not
						available, the system will automatically use the start date of the
						current year as default.
					</p>

					<p>
						<BoldText>Client Name</BoldText>: If the client name is not known,
						select “Other” and enter the name manually in the text box.
					</p>
				</Modal>
			)}
		</Wrapper>
	);
};

export default SheetSelector;
